(function () {
  'use strict';

  // ---------------------------------------------------------------------------
  // Shopify-compatible money formatter (matches slate/theme.js pattern)
  // ---------------------------------------------------------------------------
  function formatMoney(cents, format) {
    if (!format) {
      format = window.theme && window.theme.moneyFormat
        ? window.theme.moneyFormat
        : '${{amount}}';
    }

    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

    function defaultTo(val, def) {
      return (val == null || val !== val) ? def : val;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ',');
      decimal   = defaultTo(decimal,   '.');
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts        = number.split('.');
      var dollarsAmt   = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmt     = parts[1] ? decimal + parts[1] : '';
      return dollarsAmt + centsAmt;
    }

    var match = format.match(placeholderRegex);
    if (!match) return cents;
    var value = '';
    switch (match[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2); break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ','); break;
      default:
        value = formatWithDelimiters(cents, 2);
    }
    return format.replace(placeholderRegex, value);
  }

  // ---------------------------------------------------------------------------
  // CartDrawer
  // ---------------------------------------------------------------------------
  var CartDrawer = {
    drawer:       null,
    overlay:      null,
    itemsEl:      null,
    footerEl:     null,
    subtotalEl:   null,
    moneyFormat:  '${{amount}}',
    isOpen:       false,

    init: function () {
      this.drawer     = document.getElementById('CartDrawer');
      this.overlay    = document.getElementById('CartDrawerOverlay');
      this.itemsEl    = document.getElementById('CartDrawerItems');
      this.footerEl   = document.getElementById('CartDrawerFooter');
      this.subtotalEl = document.getElementById('CartDrawerSubtotal');

      if (!this.drawer) return;

      // Read money format embedded by Liquid
      this.moneyFormat = this.drawer.getAttribute('data-money-format') || '${{amount}}';

      this._bindEvents();
    },

    _bindEvents: function () {
      var self = this;

      // Close button
      document.getElementById('CartDrawerClose').addEventListener('click', function () {
        self.close();
      });

      // Overlay
      this.overlay.addEventListener('click', function () {
        self.close();
      });

      // ESC key
      document.addEventListener('keydown', function (e) {
        if ((e.key === 'Escape' || e.key === 'Esc') && self.isOpen) {
          self.close();
        }
      });

      // Cart icon in header — intercept navigation to open drawer
      document.querySelectorAll('.site-header__cart').forEach(function (el) {
        el.addEventListener('click', function (e) {
          e.preventDefault();
          self.open();
        });
      });

      // Quantity / remove — delegated on items container
      // Use closest() so clicks on child nodes (text/anonymous flex items) still resolve to the button
      this.itemsEl.addEventListener('click', function (e) {
        var btn = e.target.closest('.cart-drawer__qty-btn');
        if (btn) {
          var line       = parseInt(btn.getAttribute('data-line'), 10);
          var action     = btn.getAttribute('data-action');
          var qtyEl      = btn.closest('.cart-drawer__item-qty').querySelector('.cart-drawer__qty-value');
          var currentQty = parseInt(qtyEl.textContent, 10);
          var newQty     = action === 'increase' ? currentQty + 1 : Math.max(0, currentQty - 1);
          self._updateQuantity(line, newQty);
          return;
        }

        var removeBtn = e.target.closest('.cart-drawer__remove');
        if (removeBtn) {
          var line = parseInt(removeBtn.getAttribute('data-line'), 10);
          self._updateQuantity(line, 0);
        }
      });
    },

    open: function () {
      var self = this;
      this._fetchCart(function (cart) {
        self._renderCart(cart);
        self._updateHeaderCount(cart.item_count);
        self._show();
      });
    },

    close: function () {
      this.drawer.setAttribute('aria-hidden', 'true');
      this.overlay.setAttribute('aria-hidden', 'true');
      this.drawer.classList.remove('cart-drawer--open');
      this.overlay.classList.remove('cart-drawer__overlay--visible');
      document.body.classList.remove('cart-drawer-open');
      this.isOpen = false;
    },

    _show: function () {
      this.drawer.setAttribute('aria-hidden', 'false');
      this.overlay.setAttribute('aria-hidden', 'false');
      this.drawer.classList.add('cart-drawer--open');
      this.overlay.classList.add('cart-drawer__overlay--visible');
      document.body.classList.add('cart-drawer-open');
      this.isOpen = true;
    },

    _fetchCart: function (callback) {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(callback)
        .catch(function (err) { console.error('Cart fetch error:', err); });
    },

    _updateQuantity: function (line, qty) {
      var self = this;
      fetch('/cart/change.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ line: line, quantity: qty })
      })
        .then(function (r) {
          return r.json().then(function (data) {
            return { ok: r.ok, data: data };
          });
        })
        .then(function (result) {
          if (!result.ok) {
            // 422 — Shopify rejected the quantity; fetch current cart to re-render
            self._fetchCart(function (cart) {
              var notices = {};
              notices[line] = 'Max: ' + (cart.items[line - 1] ? cart.items[line - 1].quantity : '');
              self._renderCart(cart, notices);
              self._updateHeaderCount(cart.item_count);
            });
            return;
          }
          var cart = result.data;
          var notices = {};
          if (qty > 0) {
            var actualQty = cart.items[line - 1] ? cart.items[line - 1].quantity : qty;
            if (actualQty < qty) {
              notices[line] = 'Only ' + actualQty + ' available';
            }
          }
          self._renderCart(cart, notices);
          self._updateHeaderCount(cart.item_count);
        })
        .catch(function (err) { console.error('Cart update error:', err); });
    },

    _updateHeaderCount: function (count) {
      var el = document.getElementById('CartCount');
      if (el) el.textContent = count;
    },

    _renderCart: function (cart, notices) {
      notices = notices || {};
      var self = this;
      var html = '';

      if (cart.item_count === 0) {
        html = '<p class="cart-drawer__empty">Your bag is empty.</p>';
        if (this.footerEl) this.footerEl.classList.add('cart-drawer__footer--hidden');
      } else {
        cart.items.forEach(function (item, index) {
          var lineIndex   = index + 1;
          var variantHtml = (item.variant_title && item.variant_title !== 'Default Title')
            ? '<p class="cart-drawer__item-variant">' + self._escape(item.variant_title) + '</p>'
            : '';
          var propertiesHtml = '';
          if (item.properties) {
            var noticeColor = null;
            var configs = window.finalNoticeConfigs || [];
            var noteVal = item.properties['Note'];
            for (var n = 0; n < configs.length; n++) {
              if (configs[n].enabled && configs[n].text === noteVal) {
                noticeColor = configs[n].color;
                break;
              }
            }
            Object.keys(item.properties).forEach(function (key) {
              var val = item.properties[key];
              if (key.charAt(0) !== '_' && val !== '' && val != null) {
                var styleAttr = (key === 'Note' && noticeColor) ? ' style="color: ' + noticeColor + ';"' : '';
                propertiesHtml +=
                  '<li class="cart-drawer__item-property">' +
                    '<span class="cart-drawer__item-property-value"' + styleAttr + '>' + self._escape(String(val)) + '</span>' +
                  '</li>';
              }
            });
            if (propertiesHtml) {
              propertiesHtml = '<ul class="cart-drawer__item-properties">' + propertiesHtml + '</ul>';
            }
          }
          var imgHtml = item.image
            ? '<img src="' + item.image + '" alt="' + self._escape(item.title) + '" class="cart-drawer__item-image">'
            : '';

          html +=
            '<div class="cart-drawer__item" data-line="' + lineIndex + '">' +
              '<a href="' + item.url + '" class="cart-drawer__item-image-wrap">' + imgHtml + '</a>' +
              '<div class="cart-drawer__item-details">' +
                '<a href="' + item.url + '" class="cart-drawer__item-title">' + self._escape(item.product_title) + '</a>' +
                variantHtml +
                propertiesHtml +
                '<p class="cart-drawer__item-price">' + formatMoney(item.final_line_price, self.moneyFormat) + '</p>' +
                '<div class="cart-drawer__item-actions">' +
                  '<div class="cart-drawer__item-qty">' +
                    '<button class="cart-drawer__qty-btn" data-action="decrease" data-line="' + lineIndex + '" aria-label="Decrease quantity">\u2212</button>' +
                    '<span class="cart-drawer__qty-value">' + item.quantity + '</span>' +
                    '<button class="cart-drawer__qty-btn" data-action="increase" data-line="' + lineIndex + '" aria-label="Increase quantity">+</button>' +
                    (notices[lineIndex] ? '<span class="cart-qty__notice">' + self._escape(notices[lineIndex]) + '</span>' : '') +
                  '</div>' +
                  '<button class="cart-drawer__remove" data-line="' + lineIndex + '">Remove</button>' +
                '</div>' +
              '</div>' +
            '</div>';
        });

        if (this.footerEl) {
          this.footerEl.classList.remove('cart-drawer__footer--hidden');
          if (this.subtotalEl) {
            this.subtotalEl.textContent = formatMoney(cart.total_price, self.moneyFormat);
          }
        }
      }

      if (this.itemsEl) this.itemsEl.innerHTML = html;
    },

    _escape: function (str) {
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }
  };

  // Init on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { CartDrawer.init(); });
  } else {
    CartDrawer.init();
  }

  // Expose globally so theme.js can call CartDrawer.open() after AJAX add-to-cart
  window.CartDrawer = CartDrawer;

})();
